import type { Project } from '../../types';

/**
 * Normalize project instances by converting date-like fields to Date objects
 * and cloning nested collections to avoid accidental mutations.
 */
export const reviveProject = (project: Project): Project => ({
  ...project,
  startDate: project.startDate ? new Date(project.startDate) : new Date(),
  endDate: project.endDate ? new Date(project.endDate) : undefined,
  createdAt: project.createdAt ? new Date(project.createdAt) : new Date(),
  updatedAt: project.updatedAt ? new Date(project.updatedAt) : new Date(),
  nodes: project.nodes ? project.nodes.map((node) => ({ ...node })) : [],
  edges: project.edges ? project.edges.map((edge) => ({ ...edge })) : [],
  members: project.members ? project.members.map((member) => ({ ...member })) : [],
  settings: {
    workingHoursPerDay: project.settings?.workingHoursPerDay ?? 8,
    workingDaysPerWeek: project.settings?.workingDaysPerWeek ?? 5,
    currency: project.settings?.currency ?? 'EUR',
    timezone: project.settings?.timezone ?? 'Europe/Paris',
    dateFormat: project.settings?.dateFormat ?? 'dd/MM/yyyy',
    includeWeekends: project.settings?.includeWeekends ?? true,
    holidays: project.settings?.holidays ?? [],
  },
});
